import { render, staticRenderFns } from "./DetailFooter.vue?vue&type=template&id=4db21610&"
import script from "./DetailFooter.vue?vue&type=script&lang=js&"
export * from "./DetailFooter.vue?vue&type=script&lang=js&"
import style0 from "./DetailFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports